var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconAccessibility64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_9312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 7.11314C45.746 7.11314 56.8894 18.2566 56.8894 32.0027C56.8894 45.7488 45.746 56.8922 31.9999 56.8922C18.2538 56.8922 7.11035 45.7488 7.11035 32.0027C7.11035 18.2566 18.2538 7.11314 31.9999 7.11314ZM20.3383 22.0469C19.1916 22.0469 18.2619 22.9678 18.2619 24.1036C18.2619 25.3916 19.2429 26.4722 20.536 26.6084L26.8587 27.2748H27.7845V35.795L24.1709 47.5018C23.8292 48.6087 24.4582 49.7805 25.5759 50.1189C26.6935 50.4574 27.8765 49.8343 28.2182 48.7274L31.9287 36.7066H32.1977L35.9082 48.7274C36.2499 49.8343 37.4329 50.4574 38.5505 50.1189C39.6681 49.7805 40.2972 48.6087 39.9555 47.5018L36.2489 35.4936V27.2748H37.1747L43.4973 26.6084C44.7904 26.4722 45.7714 25.3916 45.7714 24.1036C45.7714 24.0375 45.7682 23.9714 45.7618 23.9056C45.6514 22.775 44.6365 21.9472 43.4951 22.0566L36.315 22.7445H27.7183L20.5382 22.0566C20.4718 22.0502 20.4051 22.0469 20.3383 22.0469ZM32.0167 14.3674C30.2636 14.3674 28.8425 15.7749 28.8425 17.5113C28.8425 19.2476 30.2636 20.6552 32.0167 20.6552C33.7697 20.6552 35.1909 19.2476 35.1909 17.5113C35.1909 15.7749 33.7697 14.3674 32.0167 14.3674Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0167 20.6552C33.7697 20.6552 35.1909 19.2476 35.1909 17.5113C35.1909 15.7749 33.7697 14.3674 32.0167 14.3674C30.2637 14.3674 28.8425 15.7749 28.8425 17.5113C28.8425 19.2476 30.2637 20.6552 32.0167 20.6552Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1975 36.7066H31.9284L28.218 48.7274C27.8763 49.8344 26.6933 50.4574 25.5757 50.1189C24.458 49.7805 23.829 48.6088 24.1707 47.5018L27.7842 35.795V27.2748H26.8584L20.5358 26.6084C19.2427 26.4722 18.2617 25.3916 18.2617 24.1036C18.2617 22.9678 19.1913 22.0469 20.3381 22.0469C20.4049 22.0469 20.4716 22.0502 20.538 22.0566L27.7181 22.7445H36.3148L43.4949 22.0566C44.6363 21.9472 45.6511 22.775 45.7616 23.9056C45.768 23.9714 45.7712 24.0375 45.7712 24.1036C45.7712 25.3916 44.7902 26.4722 43.4971 26.6084L37.1745 27.2748H36.2487V35.4936L39.9552 47.5018C40.2969 48.6088 39.6679 49.7805 38.5503 50.1189C37.4327 50.4574 36.2496 49.8344 35.9079 48.7274L32.1975 36.7066Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_9312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconAccessibility64);
export default __webpack_public_path__ + "static/media/pictogramBeaconAccessibility64.36ade029b9cf404432c1cc50ca7a4792.svg";
export { ForwardRef as ReactComponent };